import { render, staticRenderFns } from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=template&id=a43e10c4"
import script from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaProfissionaisEquipesMedicas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports